import React from 'react';
import '../../../css/gardenManagerStylings/plantsSection/ReminderEntryStyling.css';

const ReminderEntryComponent = ({
                          reminder,
                          gardenName,
                          onToggleComplete,
                          formatDateTime,
                          isOverdue,
                          getPriorityIcon,
                          getPlantName
                      }) => {
    return (
        <div
            key={reminder.id}
            className={`reminder-item ${reminder.is_completed ? 'completed' : ''} ${isOverdue(reminder.reminder_datetime) && !reminder.is_completed ? 'overdue' : ''}`}
        >
            <div className="reminder-checkbox">
                <input
                    type="checkbox"
                    checked={reminder.is_completed}
                    onChange={() => onToggleComplete(reminder.id)}
                    className="custom-checkbox"
                />
            </div>

            <div className="reminder-content">
                <div className="reminder-header">
                    <div className="reminder-title">
                        {getPriorityIcon(reminder.priority)}
                        <span>{reminder.title}</span>
                    </div>
                    <div
                        className={`reminder-time ${isOverdue(reminder.reminder_datetime) && !reminder.is_completed ? 'overdue-text' : ''}`}>
                        {isOverdue(reminder.reminder_datetime) && !reminder.is_completed && "⚠️ "}
                        {formatDateTime(reminder.reminder_datetime)}
                    </div>
                </div>

                {reminder.description && (
                    <div className="reminder-description">
                        {reminder.description}
                    </div>
                )}

                <div className="reminder-meta">
                    {getPlantName(reminder.plant_id) && (
                        <span className="reminder-plant">
                            🌱 {getPlantName(reminder.plant_id)}
                        </span>
                    )}
                    {gardenName && (
                        <span className="reminder-garden">
                            🏡 {gardenName}
                        </span>
                    )}
                    {reminder.tags && reminder.tags.length > 0 && (
                        <div className="reminder-tags">
                            {reminder.tags.map((tag, index) => (
                                <span key={index} className="reminder-tag">
                                    #{tag}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReminderEntryComponent;